import PropTypes from 'prop-types';
import BaseDetails from 'containers/Base/BaseDetails.js';
import { useDispatch, useSelector } from 'react-redux';
import { visitorTypeActions, visitorTypeNS, visitorTypeSelectors } from '../';
import React, { useCallback, useEffect } from 'react';
import { toggleModal } from 'reducers/ui';
import isEmpty from 'lodash/isEmpty';

const VisitorTypeDetail = ({ id, cancel, editable, toggleEditMode }) => {
  const dispatch = useDispatch();
  const details = useSelector(state =>
    visitorTypeSelectors.getVisitorTypeTransformed(state),
  );
  const setVisitorTypeID = useCallback(
    id => {
      dispatch(visitorTypeActions.setSelectedRowID(id));
    },
    [dispatch],
  );
  const removeVisitorTypeDetails = useCallback(
    () => dispatch(visitorTypeActions.setGridRowDetails({ details: null })),
    [dispatch],
  );
  const dispatchFetchVisitorTypeDetails = useCallback(
    id => dispatch(visitorTypeActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(visitorTypeNS)),
    [dispatch],
  );
  useEffect(() => {
    if (id) {
      dispatchFetchVisitorTypeDetails(id);
      setVisitorTypeID(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const onEdit = () => {
    toggleEditMode();
    dispatchToggleModal(visitorTypeNS);
  };
  const cancelAndRemoveDetails = () => {
    cancel();
    setVisitorTypeID(null);
    removeVisitorTypeDetails();
  };
  const canEdit = editable => {
    if (editable) {
      if (details && !isEmpty(details.generalInfo)) {
        return !details.generalInfo.systemRequired.value;
      }
    }
    return false;
  };
  return (
    <BaseDetails
      header={'Visitor Type Details'}
      details={details}
      cancel={cancelAndRemoveDetails}
      editable={canEdit(editable)}
      onEdit={onEdit}
    />
  );
};
VisitorTypeDetail.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
  editable: PropTypes.bool,
  toggleEditMode: PropTypes.func,
};
export default VisitorTypeDetail;
